import React from "react";
import "../style.css";
import test from "../../Images/test1.jpg";
import vid1 from "../../Video/vid1.mp4";
import vid2 from "../../Video/vid2.mp4";
import vid3 from "../../Video/vid3.mp4";

const ProductHoverSection = () => {
  return (
    <>
      <div className="main-container">
        <div className="text-with-img">
          <span className="product-hover-text">Dynamic Hero Sections</span>
          <video
            src={vid1}
            className="hover-video"
            autoPlay
            loop
            muted
            playsInline
          />
          <span className="product-hover-text">Custom Carousels</span>
        </div>
        <div className="text-with-img">
          <span className="product-hover-text">Engaging FAQs</span>
          <video
            src={vid2}
            className="hover-video"
            autoPlay
            loop
            muted
            playsInline
          />
          <span className="product-hover-text">Modern Testimonials</span>
          <video
            src={vid3}
            className="hover-video"
            autoPlay
            loop
            muted
            playsInline
          />
        </div>
      </div>
    </>
  );
};

export default ProductHoverSection;
